const URRU_PLAYA_PICKUPS = Object.freeze({
  'playacar-center': Object.freeze({
    label: 'Playacar Center',
    times: Object.freeze({ 'xcaret-plus': '09:20', xelha: '07:20', 'xplor-day': '09:20', 'xplor-fire': '16:25', xenses: '09:20 / 12:20', xochimilco: '17:30', xenotes: '08:50', 'xichen-deluxe': '07:20' })
  }),
  'plaza-antigua': Object.freeze({
    label: 'Plaza Antigua',
    times: Object.freeze({ 'xcaret-plus': '09:10', xelha: '07:20', 'xplor-day': '09:10', 'xplor-fire': '16:45', xenses: '09:10 / 12:40', xochimilco: '17:05', xenotes: '09:00', 'xichen-deluxe': '07:20' })
  }),
  'old-navy': Object.freeze({
    label: 'Old Navy',
    times: Object.freeze({ 'xcaret-plus': '09:00', xelha: '07:00', 'xplor-day': '09:00', 'xplor-fire': '16:40', xenses: '09:00 / 12:35', xochimilco: '17:15', 'xichen-deluxe': '07:00' })
  }),
  'plaza-las-perlas': Object.freeze({
    label: 'Plaza Las Perlas',
    times: Object.freeze({ 'xcaret-plus': '09:00', xelha: '07:00', 'xplor-day': '09:00', 'xplor-fire': '16:05', xenses: '09:00 / 12:00', xochimilco: '17:30', xenotes: '08:45', 'xichen-deluxe': '07:00' })
  }),
  'bodeguita-del-medio': Object.freeze({
    label: 'Bodeguita del 1/2',
    times: Object.freeze({ 'xcaret-plus': '09:30', xelha: '07:20', 'xplor-day': '07:20', 'xplor-fire': '16:30', xenses: '07:20 / 12:20', xochimilco: '17:45', xenotes: '09:00', 'xichen-deluxe': '07:20' })
  })
});

class UrruXcaretBuilder {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-builder-form]');
    this.endpoint = root.dataset.quoteEndpoint;
    this.i18n = this.readTranslations();
    this.childrenInput = root.querySelector('[data-children-count]');
    this.originInput = root.querySelector('select[name="origin"]');
    this.pickupWrapper = root.querySelector('[data-pickup-wrapper]');
    this.pickupInput = root.querySelector('[data-meeting-point]');
    this.ages = root.querySelector('[data-child-ages]');
    this.ageFields = root.querySelector('[data-child-age-fields]');
    this.experienceInputs = [...root.querySelectorAll('input[name="experiences"]')];
    this.dateStep = root.querySelector('[data-date-step]');
    this.dateFields = root.querySelector('[data-date-fields]');
    this.messageBox = root.querySelector('[data-form-messages]');
    this.result = root.querySelector('[data-quote-result]');
    this.submitButton = root.querySelector('[type="submit"]');
    this.reserveButton = root.querySelector('[data-reserve-link]');
    this.lastQuote = null;
    this.lastPayload = null;
    this.experienceNames = new Map(this.experienceInputs.map((input) => [
      input.value,
      input.closest('label').querySelector('strong').textContent
    ]));
    this.bind();
    this.renderChildAges();
    this.updatePickupVisibility();
    this.renderDates();
  }

  readTranslations() {
    try {
      return JSON.parse(this.root.querySelector('[data-urru-xcaret-i18n]').textContent);
    } catch {
      return {};
    }
  }

  text(key, fallback = '') {
    return this.i18n[key] || fallback;
  }

  format(key, count) {
    return this.text(key).replace('{{ count }}', String(count));
  }

  bind() {
    this.childrenInput.addEventListener('input', () => this.renderChildAges());
    this.originInput.addEventListener('change', () => {
      this.updatePickupVisibility();
      this.renderDates();
    });
    this.pickupInput.addEventListener('change', () => this.renderDates());
    this.experienceInputs.forEach((input) => input.addEventListener('change', (event) => this.handleExperienceChange(event)));
    this.form.addEventListener('submit', (event) => this.submit(event));
    this.reserveButton.addEventListener('click', () => this.checkout());
  }

  selectedExperiences() {
    return this.experienceInputs.filter((input) => input.checked).map((input) => input.value);
  }

  updatePickupVisibility() {
    const isPlaya = this.originInput.value === 'playa-del-carmen';
    this.pickupWrapper.hidden = !isPlaya;
    this.pickupInput.required = isPlaya;
    if (!isPlaya) this.pickupInput.value = '';
  }

  pickupFor(code, point = this.pickupInput.value) {
    return URRU_PLAYA_PICKUPS[point]?.times?.[code] || '';
  }

  pickupLabel(point = this.pickupInput.value) {
    return URRU_PLAYA_PICKUPS[point]?.label || '';
  }

  interpolate(key, values = {}) {
    return Object.entries(values).reduce(
      (text, [name, value]) => text.replaceAll(`{{ ${name} }}`, String(value)).replaceAll(`{{${name}}}`, String(value)),
      this.text(key)
    );
  }

  handleExperienceChange(event) {
    const selected = this.selectedExperiences();
    if (selected.length > 4) {
      event.target.checked = false;
      this.showMessage(this.text('maxExperiences'));
    } else {
      this.showMessage('');
    }
    this.renderDates();
  }

  renderChildAges() {
    const count = Math.max(0, Math.min(12, Number(this.childrenInput.value) || 0));
    const previous = [...this.ageFields.querySelectorAll('select')].map((select) => select.value);
    this.ageFields.replaceChildren();
    this.ages.hidden = count === 0;
    for (let index = 0; index < count; index += 1) {
      const label = document.createElement('label');
      const title = document.createElement('span');
      const select = document.createElement('select');
      title.textContent = `${this.text('childLabel')} ${index + 1}`;
      select.name = `child_age_${index + 1}`;
      select.required = true;
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.text('agePlaceholder');
      select.append(placeholder);
      for (let age = 0; age < 12; age += 1) {
        const option = document.createElement('option');
        option.value = String(age);
        option.textContent = `${age} ${this.text('years')}`;
        select.append(option);
      }
      if (previous[index] !== undefined) select.value = previous[index];
      label.append(title, select);
      this.ageFields.append(label);
    }
  }

  renderDates() {
    const selected = this.selectedExperiences();
    const previous = new Map([...this.dateFields.querySelectorAll('input')].map((input) => [input.dataset.experience, input.value]));
    this.dateFields.replaceChildren();
    this.root.querySelector('[data-selection-count]').textContent = selected.length;
    this.root.querySelector('[data-selection-suffix]').textContent = this.text('selectedSuffix');
    this.dateStep.hidden = selected.length === 0;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minimum = [
      tomorrow.getFullYear(),
      String(tomorrow.getMonth() + 1).padStart(2, '0'),
      String(tomorrow.getDate()).padStart(2, '0'),
    ].join('-');
    selected.forEach((code) => {
      const row = document.createElement('div');
      const name = document.createElement('strong');
      const label = document.createElement('label');
      const labelText = document.createElement('span');
      const input = document.createElement('input');
      row.className = 'urru-xcaret__date-row';
      name.textContent = this.experienceNames.get(code);
      labelText.textContent = this.text('visitDate');
      input.type = 'date';
      input.name = `date_${code}`;
      input.dataset.experience = code;
      input.min = minimum;
      input.required = true;
      input.value = previous.get(code) || '';
      label.append(labelText, input);
      row.append(name, label);
      if (this.originInput.value === 'playa-del-carmen' && this.pickupInput.value) {
        const pickup = document.createElement('p');
        const time = this.pickupFor(code);
        pickup.className = 'urru-xcaret__pickup-time';
        pickup.textContent = time
          ? this.interpolate('pickupDetail', { point: this.pickupLabel(), time })
          : this.text('pickupUnavailable');
        if (!time) pickup.classList.add('urru-xcaret__pickup-time--unavailable');
        row.append(pickup);
      }
      this.dateFields.append(row);
    });
  }

  payload() {
    const data = new FormData(this.form);
    const experiences = this.selectedExperiences().map((code) => ({ code, date: data.get(`date_${code}`) }));
    const children = Number(data.get('children')) || 0;
    return {
      origin: data.get('origin'),
      meetingPoint: data.get('origin') === 'playa-del-carmen' ? data.get('meeting_point') : null,
      visitorType: data.get('visitor_type'),
      passengers: {
        adults: Number(data.get('adults')) || 0,
        childAges: Array.from({ length: children }, (_, index) => Number(data.get(`child_age_${index + 1}`)))
      },
      experiences,
      productHandle: window.location.pathname.split('/').filter(Boolean).pop() || null
    };
  }

  validate(payload) {
    if (!payload.origin || !payload.visitorType) return this.text('originVisitor');
    if (payload.origin === 'playa-del-carmen' && !payload.meetingPoint) return this.text('meetingPointRequired');
    if (payload.passengers.adults < 1) return this.text('adultRequired');
    if (payload.passengers.childAges.some((age) => Number.isNaN(age))) return this.text('childAgeRequired');
    if (payload.experiences.length < 1 || payload.experiences.length > 4) return this.text('experienceCount');
    if (payload.experiences.some((experience) => !experience.date)) return this.text('dateRequired');
    if (payload.origin === 'playa-del-carmen' && payload.experiences.some((experience) => !this.pickupFor(experience.code, payload.meetingPoint))) {
      return this.text('pickupUnavailable');
    }
    const uniqueDates = new Set(payload.experiences.map((experience) => experience.date));
    if (uniqueDates.size !== payload.experiences.length) return this.text('distinctDates');
    const visitTimes = payload.experiences.map((experience) => new Date(`${experience.date}T12:00:00Z`).getTime());
    const visitWindowDays = (Math.max(...visitTimes) - Math.min(...visitTimes)) / 86400000;
    if (visitWindowDays > 14) return this.text('dateWindow');
    return '';
  }

  async submit(event) {
    event.preventDefault();
    const payload = this.payload();
    const error = this.validate(payload);
    if (error) {
      this.showMessage(error);
      return;
    }
    this.showMessage('');
    this.submitButton.disabled = true;
    this.submitButton.textContent = this.text('checking');
    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('quote_unavailable');
      this.renderResult(await response.json(), payload);
    } catch {
      this.renderResult({ status: 'needs_confirmation' }, payload);
    } finally {
      this.submitButton.disabled = false;
      this.submitButton.textContent = this.text('calculate');
    }
  }

  checkoutEndpoint() {
    const endpoint = new URL(this.endpoint, window.location.origin);
    endpoint.pathname = endpoint.pathname.replace(/\/quote\/?$/, '/checkout');
    return endpoint.toString();
  }

  async checkout() {
    if (!this.lastQuote || !this.lastPayload) return;
    this.showMessage('');
    this.reserveButton.disabled = true;
    this.reserveButton.textContent = this.text('preparingCheckout');
    try {
      const response = await fetch(this.checkoutEndpoint(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          ...this.lastPayload,
          quoteId: this.lastQuote.quoteId,
          expectedPriceMxn: this.lastQuote.publicPriceMxn
        })
      });
      const result = await response.json();
      if (response.status === 409 && result.status === 'price_changed' && result.quote) {
        this.renderResult(result.quote, this.lastPayload);
        this.showMessage(this.text('priceChanged'));
        return;
      }
      if (!response.ok || !result.checkoutUrl) throw new Error('checkout_unavailable');
      window.location.assign(result.checkoutUrl);
    } catch {
      this.showMessage(this.text('checkoutError'));
    } finally {
      this.reserveButton.disabled = false;
      this.reserveButton.textContent = this.text('reserve');
    }
  }

  renderResult(quote, payload) {
    this.result.hidden = false;
    this.result.querySelector('[data-result-title]').textContent = quote.status === 'confirmed'
      ? this.text('available')
      : this.text('pending');
    const prices = this.result.querySelector('[data-result-prices]');
    const notices = this.result.querySelector('[data-result-notices]');
    const reserve = this.result.querySelector('[data-reserve-link]');
    const pickupSummary = this.result.querySelector('[data-result-pickups]');
    prices.replaceChildren();
    notices.replaceChildren();
    reserve.hidden = true;
    pickupSummary.hidden = true;
    this.lastQuote = null;
    this.lastPayload = null;

    this.renderPickupSummary(payload);
    if (quote.status === 'confirmed') {
      [
        [this.text('dueNow'), quote.dueNow, 'urru-xcaret__price--primary'],
        [this.text('balanceOnArrival'), quote.balanceOnArrival],
        [this.text('priceUrru'), quote.publicPrice],
        [this.text('officialReference'), quote.officialReference],
        [this.text('savings'), quote.customerSavings]
      ].forEach(([label, value, className]) => {
        if (!value) return;
        const box = document.createElement('div');
        const labelNode = document.createElement('span');
        const valueNode = document.createElement('strong');
        box.className = `urru-xcaret__price${className ? ` ${className}` : ''}`;
        labelNode.textContent = label;
        valueNode.textContent = value;
        box.append(labelNode, valueNode);
        prices.append(box);
      });
      this.appendNotice(notices, this.format('packageNotice', payload.experiences.length));
      this.appendNotice(notices, this.text('paymentNotice'));
      const freeChildren = payload.passengers.childAges.filter((age) => age < 5).length;
      if (freeChildren > 0) {
        this.appendNotice(notices, this.format(freeChildren === 1 ? 'freeChildOne' : 'freeChildMany', freeChildren));
      }
      this.appendNotice(notices, this.text('recheckNotice'));
      if (
        quote.quoteId &&
        Number.isFinite(Number(quote.publicPriceMxn)) &&
        Number.isFinite(Number(quote.dueNowMxn)) &&
        Number.isFinite(Number(quote.balanceOnArrivalMxn))
      ) {
        this.lastQuote = quote;
        this.lastPayload = payload;
        reserve.hidden = false;
      }
    } else {
      this.appendNotice(notices, this.text('pendingNotice'));
    }
    this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  renderPickupSummary(payload) {
    const summary = this.result.querySelector('[data-result-pickups]');
    const heading = summary.querySelector('[data-result-pickup-heading]');
    const list = summary.querySelector('[data-result-pickup-list]');
    list.replaceChildren();
    if (payload.origin !== 'playa-del-carmen' || !payload.meetingPoint) {
      summary.hidden = true;
      return;
    }
    heading.textContent = this.text('pickupHeading');
    payload.experiences.forEach((experience) => {
      const time = this.pickupFor(experience.code, payload.meetingPoint);
      if (!time) return;
      const item = document.createElement('li');
      item.textContent = `${this.experienceNames.get(experience.code)} · ${experience.date} · ${this.interpolate('pickupDetail', { point: this.pickupLabel(payload.meetingPoint), time })}`;
      list.append(item);
    });
    summary.hidden = list.children.length === 0;
  }

  appendNotice(list, text) {
    if (!text) return;
    const item = document.createElement('li');
    item.textContent = text;
    list.append(item);
  }

  showMessage(message) {
    this.messageBox.textContent = message;
  }
}

document.querySelectorAll('[data-urru-xcaret]').forEach((root) => new UrruXcaretBuilder(root));

